import { StripeCreditCardType } from '@ctct/domain-layer';

export const paymentMethodsEnum = {
  VISA_ABBREVIATED: 'VI',
  VISA_WORD: 'visa',
  MASTERCARD_ABBREVIATED: 'MC',
  MASTERCARD_WORD: 'mastercard',
  AMERICANEXPRESS_ABBREVIATED: 'AX',
  AMERICANEXPRESS_WORD: 'amex',
  DISCOVER_ABBREVIATED: 'DI',
  DISCOVER_WORD: 'discover',
};

export const enum CreditCardDisplayString {
  VISA = 'Visa',
  MASTERCARD = 'Mastercard',
  AMERICANEXPRESS = 'American Express',
  DISCOVER = 'Discover',
  CREDIT_CARD = 'Credit card',
}

export const enum PaymentLogoName {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  AMERICANEXPRESS = 'americanExpress',
  DISCOVER = 'discover',
  CREDIT_CARD = 'Credit card',
}

export function transformCreditCardName(cardType?: string) {
  if (!cardType) return '';

  switch (cardType) {
    case paymentMethodsEnum.VISA_ABBREVIATED:
    case paymentMethodsEnum.VISA_WORD:
      return CreditCardDisplayString.VISA;
    case paymentMethodsEnum.MASTERCARD_ABBREVIATED:
    case paymentMethodsEnum.MASTERCARD_WORD:
      return CreditCardDisplayString.MASTERCARD;
    case paymentMethodsEnum.AMERICANEXPRESS_ABBREVIATED:
    case paymentMethodsEnum.AMERICANEXPRESS_WORD:
      return CreditCardDisplayString.AMERICANEXPRESS;
    case paymentMethodsEnum.DISCOVER_ABBREVIATED:
    case paymentMethodsEnum.DISCOVER_WORD:
      return CreditCardDisplayString.DISCOVER;
    default:
      return CreditCardDisplayString.CREDIT_CARD;
  }
}

export function transformStripeCreditCardName(cardType?: string) {
  if (!cardType) return '';

  switch (cardType) {
    case 'visa':
      return CreditCardDisplayString.VISA;
    case 'mastercard':
      return CreditCardDisplayString.MASTERCARD;
    case 'amex':
      return CreditCardDisplayString.AMERICANEXPRESS;
    case 'discover':
      return CreditCardDisplayString.DISCOVER;
    default:
      return CreditCardDisplayString.CREDIT_CARD;
  }
}

export function getPaymentLogoName(cardType?: string) {
  if (!cardType) return '';

  switch (cardType) {
    case paymentMethodsEnum.VISA_ABBREVIATED:
    case paymentMethodsEnum.VISA_WORD:
      return PaymentLogoName.VISA;
    case paymentMethodsEnum.MASTERCARD_ABBREVIATED:
    case paymentMethodsEnum.MASTERCARD_WORD:
      return PaymentLogoName.MASTERCARD;
    case paymentMethodsEnum.AMERICANEXPRESS_ABBREVIATED:
    case paymentMethodsEnum.AMERICANEXPRESS_WORD:
      return PaymentLogoName.AMERICANEXPRESS;
    case paymentMethodsEnum.DISCOVER_ABBREVIATED:
    case paymentMethodsEnum.DISCOVER_WORD:
      return PaymentLogoName.DISCOVER;
    default:
      return PaymentLogoName.CREDIT_CARD;
  }
}

export function getStripePaymentLogoName(cardType?: string) {
  if (!cardType) return '';

  switch (cardType) {
    case StripeCreditCardType.VISA:
      return PaymentLogoName.VISA;
    case StripeCreditCardType.MASTERCARD:
      return PaymentLogoName.MASTERCARD;
    case StripeCreditCardType.AMEX:
      return PaymentLogoName.AMERICANEXPRESS;
    case StripeCreditCardType.DISCOVER:
      return PaymentLogoName.DISCOVER;
    default:
      return PaymentLogoName.CREDIT_CARD;
  }
}
